// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.f1679a79b',
  revision: 'f1679a79b',
  branch: 'develop',
  date: 'Tue, 29 Sep 2026 14:21:02 GMT'
};